module.exports = "button.nav-link {\n  padding: 0;\n  border-radius: 0;\n  padding-top: 0.3em; }\n"